import { render, staticRenderFns } from "./chat-user-list.vue?vue&type=template&id=dff8a0a2&scoped=true"
import script from "./chat-user-list.vue?vue&type=script&lang=js"
export * from "./chat-user-list.vue?vue&type=script&lang=js"
import style0 from "./chat-user-list.vue?vue&type=style&index=0&id=dff8a0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8a0a2",
  null
  
)

export default component.exports